module.exports = __webpack_public_path__ + "static/temperature-0b9bd3db4d7aa77a316b954ca3e24fb5.webp";